import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["className", "clientId", "isReadonly", "onKeyDown", "onKeyUp", "value"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { getClientId, useIsComposingHandler } from "@smartsheet/lodestar-utils";
import React, { forwardRef } from "react";
import { noop } from "../../../../constants/noop";
var sharedStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    font-size: inherit;\n    font-weight: inherit;\n    font-family: inherit;\n    line-height: inherit;\n    font-style: normal;\n    color: inherit;\n\n    // Just need a bit more space over the what the Inline already gives us.\n    padding-left: 4px;\n"])));
var AutoSizeInputRoot = styled("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n\n    display: inline-block;\n    width: auto;\n    /* height: auto; */\n    position: relative;\n    height: 28px;\n"])), sharedStyles);
var AutoSizeInputSpacer = styled("span")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    visibility:hidden;\n    display: inline;\n    white-space: pre;\n"])), sharedStyles);
var AutoSizeInputInput = styled("input")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n\n    box-sizing:content-box;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    // Just need a bit more space over the what the Inline already gives us.\n    left: 6px;\n    width: 100%;\n\n    margin: 0;\n    padding: 0;\n\n    border: none;\n    outline: none;\n    min-height: 28px;\n    min-width: 1px;\n    background-color: transparent;\n\n    cursor: ", ";\n"])), sharedStyles, function (_ref) {
  var readOnly = _ref.readOnly;
  return readOnly ? "default" : "text";
});
export var AutoSizeInput = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    clientId = _ref2.clientId,
    isReadonly = _ref2.isReadonly,
    onKeyDown = _ref2.onKeyDown,
    onKeyUp = _ref2.onKeyUp,
    value = _ref2.value,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var handleKeyDown = useIsComposingHandler(onKeyDown || noop);
  var handleKeyUp = useIsComposingHandler(onKeyUp || noop);
  return /*#__PURE__*/React.createElement(AutoSizeInputRoot, {
    className: className
  }, /*#__PURE__*/React.createElement(AutoSizeInputSpacer, null, value), /*#__PURE__*/React.createElement(AutoSizeInputInput, _extends({
    readOnly: isReadonly,
    value: value,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp
  }, rest, {
    "data-client-id": getClientId(clientId, "-input"),
    ref: ref
  })));
});
AutoSizeInput.displayName = "AutoSizeInput";
//# sourceMappingURL=AutoSizeInput.js.map